import { render, staticRenderFns } from "./AuthWrapper.vue?vue&type=template&id=79091b2e&scoped=true"
import script from "./AuthWrapper.vue?vue&type=script&lang=js"
export * from "./AuthWrapper.vue?vue&type=script&lang=js"
import style0 from "./AuthWrapper.vue?vue&type=style&index=0&id=79091b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79091b2e",
  null
  
)

export default component.exports